var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../../libs/gojs/release/go';
import { LineElement } from '../base/line-element';
import { DiagramConsts } from '../../diagram-consts';
import * as _ from 'lodash';
var TableElement = /** @class */ (function (_super) {
    __extends(TableElement, _super);
    function TableElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableElement.prototype.compile = function (model, data, _svg) {
        model['version'] = 4;
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
    };
    TableElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/table.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    TableElement.prototype.getDiagramTemplate = function (containerId) {
        var _this = this;
        var $ = go.GraphObject.make;
        var cxElement = document.getElementById('contextMenu' + containerId);
        var myContextMenu = $(go.HTMLInfo, {
            show: this.showContextMenu,
            mainElement: cxElement
        });
        return $(go.Node, 'Spot', {
            resizable: true, resizeObjectName: 'SHAPE',
            selectionAdorned: true, selectionObjectName: 'SHAPE',
            reshapable: true, locationObjectName: 'SHAPE',
            locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder, new go.Binding('padding', '', function (data) {
                return -data.strokeWidth / 2;
            })))),
            contextMenu: myContextMenu
        }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('zOrder'), $(go.Shape, { fill: '#ffffff', stroke: '#8ea0aa', strokeWidth: 1 }, new go.Binding('stroke'), new go.Binding('fill')), $(go.Panel, 'Table', {
            name: 'TABLE', stretch: go.GraphObject.Horizontal,
            defaultAlignment: go.Spot.Left,
            defaultStretch: go.GraphObject.Horizontal,
            defaultRowSeparatorStroke: '#8ea0aa',
            defaultColumnSeparatorStroke: '#8ea0aa'
        }, new go.Binding('defaultRowSeparatorStroke', 'splitLine'), new go.Binding('defaultColumnSeparatorStroke', 'splitLine'), new go.Binding('defaultColumnSeparatorStroke', '', function (data) {
            if (data.isHiddenColumnSplitLine) {
                return 'transparent';
            }
            else {
                return data.splitLine;
            }
        }), new go.Binding('defaultRowSeparatorStroke', '', function (data) {
            if (data.isHiddenRowSplitLine) {
                return 'transparent';
            }
            else {
                return data.splitLine;
            }
        }), new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), $(go.RowColumnDefinition, this.makeWidthBinding(0)), $(go.RowColumnDefinition, this.makeWidthBinding(1)), $(go.RowColumnDefinition, this.makeWidthBinding(2)), $(go.RowColumnDefinition, this.makeWidthBinding(3)), $(go.RowColumnDefinition, this.makeWidthBinding(4)), $(go.RowColumnDefinition, this.makeWidthBinding(5)), $(go.RowColumnDefinition, this.makeWidthBinding(6)), $(go.RowColumnDefinition, this.makeWidthBinding(7)), $(go.RowColumnDefinition, this.makeWidthBinding(8)), $(go.RowColumnDefinition, this.makeWidthBinding(9)), $(go.RowColumnDefinition, this.makeHeightBinding(0)), $(go.RowColumnDefinition, this.makeHeightBinding(1)), $(go.RowColumnDefinition, this.makeHeightBinding(2)), $(go.RowColumnDefinition, this.makeHeightBinding(3)), $(go.RowColumnDefinition, this.makeHeightBinding(4)), $(go.RowColumnDefinition, this.makeHeightBinding(5)), $(go.RowColumnDefinition, this.makeHeightBinding(6)), $(go.RowColumnDefinition, this.makeHeightBinding(7)), $(go.RowColumnDefinition, this.makeHeightBinding(8)), $(go.RowColumnDefinition, this.makeHeightBinding(9)), new go.Binding('itemArray', 'items'), {
            itemTemplate: $(go.Panel, 'TableRow', 
            // which in turn consists of a collection of cell objects,
            // held by the 'columns' property in an Array
            new go.Binding('itemArray', 'columns'), 
            // you could also have other Bindings here for the whole row
            {
                itemTemplate: // bound to a cell object
                $(go.Panel, // each of which as 'attr' and 'text' properties
                { stretch: go.GraphObject.Fill, alignment: go.Spot.TopLeft }, new go.Binding('column', 'column'), 
                // you could also have other Bindings here for this cell
                $(go.TextBlock, { editable: false }, { margin: new go.Margin(2, 2, 0, 2), wrap: go.TextBlock.None }, new go.Binding('text').makeTwoWay()))
            }),
        }));
    };
    TableElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.tableKey;
    };
    TableElement.prototype.makeWidthBinding = function (idx) {
        return [
            { column: idx },
            new go.Binding('width', 'widths', function (widths) {
                if (Array.isArray(widths) && idx < widths.length) {
                    return widths[idx];
                }
                return 0;
            }).makeTwoWay(function (w, data) {
                var arr = _.cloneDeep(data.widths);
                if (!arr) {
                    arr = [];
                }
                if (idx >= arr.length) {
                    for (var i = arr.length; i <= idx; i++) {
                        arr[i] = 0;
                    } // default to NaN
                }
                arr[idx] = w;
                return arr;
            })
        ];
    };
    TableElement.prototype.makeHeightBinding = function (idx) {
        return [
            { row: idx },
            new go.Binding('height', 'heights', function (heights) {
                if (Array.isArray(heights) && idx < heights.length) {
                    return heights[idx];
                }
                return 0;
            }).makeTwoWay(function (w, data) {
                var arr = _.cloneDeep(data.heights);
                if (!arr) {
                    arr = [];
                }
                if (idx >= arr.length) {
                    for (var i = arr.length; i <= idx; i++) {
                        arr[i] = 0;
                    } // default to NaN
                }
                arr[idx] = w;
                return arr;
            })
        ];
    };
    TableElement.prototype.showContextMenu = function (obj, diagram, tool) {
        // Now show the whole context menu element
        var containerId = diagram.containerId.replace('View-', '');
        $('#contextMenu' + containerId).css('display', 'block');
        // we don't bother overriding positionContextMenu, we just do it here:
        var mousePt = diagram.lastInput.viewPoint;
        $('#contextMenu' + containerId).css('left', mousePt.x + 'px');
        $('#contextMenu' + containerId).css('top', mousePt.y + 'px');
    };
    return TableElement;
}(LineElement));
export { TableElement };
